import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Videos from "@/pages/Videos";
import VideoDetail from "@/pages/VideoDetail";
import Music from "@/pages/Music";
import Profile from "@/pages/Profile";
import Chat from "@/pages/Chat";
import PublicProfile from "@/pages/PublicProfile";
import PublicVideo from "@/pages/PublicVideo";
import Explore from "@/pages/Explore";
import CultureTopic from "@/pages/CultureTopic";
import Photos from "@/pages/Photos";
import Events from "@/pages/Events";
import Konesans from "@/pages/Konesans";
import InstallPrompt from "@/components/InstallPrompt";

function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/u/:handle" element={<PublicProfile />} />
            <Route path="/v/:videoId" element={<PublicVideo />} />
            <Route
              path="/app/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route index element={<Dashboard />} />
                      <Route path="explore" element={<Explore />} />
                      <Route path="explore/:slug" element={<CultureTopic />} />
                      <Route path="videos" element={<Videos />} />
                      <Route path="videos/:id" element={<VideoDetail />} />
                      <Route path="music" element={<Music />} />
                      <Route path="photos" element={<Photos />} />
                      <Route path="events" element={<Events />} />
                      <Route path="shop" element={<Events />} />
                      <Route path="konesans" element={<Konesans />} />
                      <Route path="profile" element={<Profile />} />
                      <Route path="chat" element={<Chat />} />
                      <Route path="*" element={<Navigate to="/app" replace />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <InstallPrompt />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: { background: "#141414", border: "1px solid #2a2a2a", color: "#f5f5f5", borderRadius: 2 },
          }}
        />
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
